// extracted by mini-css-extract-plugin
module.exports = {"footer":"FlavorFinderFooter_footer__WlF7j","stickyNav":"FlavorFinderFooter_stickyNav__QMopK"};